var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Circled2Green(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#5dd39e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,4c-11.046,0 -20,8.954 -20,20c0,11.046 8.954,20 20,20c11.046,0 20,-8.954 20,-20c0,-11.046 -8.954,-20 -20,-20zM24,7c9.374,0 17,7.626 17,17c0,9.374 -7.626,17 -17,17c-9.374,0 -17,-7.626 -17,-17c0,-9.374 7.626,-17 17,-17zM24,14c-3.309,0 -6,2.691 -6,6v0.5c0,0.829 0.671,1.5 1.5,1.5c0.829,0 1.5,-0.671 1.5,-1.5v-0.5c0,-1.654 1.346,-3 3,-3c1.654,0 3,1.346 3,3c0,1.771 -1.01634,3.3412 -2.52734,3.9082l-0.43945,0.16211c-2.403,0.879 -6.0332,2.20969 -6.0332,8.42969c0,0.829 0.671,1.5 1.5,1.5h9c0.829,0 1.5,-0.671 1.5,-1.5c0,-0.829 -0.671,-1.5 -1.5,-1.5h-7.40234c0.401,-2.806 2.0048,-3.39333 3.9668,-4.11133l0.46289,-0.17187c2.675,-1.003 4.47266,-3.7028 4.47266,-6.7168c0,-3.309 -2.691,-6 -6,-6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Circled2Green);
export default __webpack_public_path__ + "static/media/icons8-circled-2-green.2d749f07a73b72b630070da982a14bbd.svg";
export { ForwardRef as ReactComponent };